export default __webpack_public_path__ + "static/media/17.9f5649cc.png";